import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetUserSettingsApiRequest } from "api/UsersController";
import { setSettings } from "../slices/userSlice";

export const fetchUserSettings = createAsyncThunk(
  "user/fetchUserSettings",
  async (_, { dispatch }) => {
    const response = await GetUserSettingsApiRequest();

    if (response?.status === "success") {
      const authOptions = response.data!.AuthenticationOptions || {
        Email: true,
        MicrosoftSSO: true,
        GoogleSSO: true,
      };

      const payload = {
        ...response.data!,
        ...authOptions,
      };
      
      dispatch(setSettings(payload));
    }

    return response;
  }
);
